// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3GLOk","controls":"styles_controls__2VBMv","charLimit":"styles_charLimit__EKHNT","input":"styles_input__2W4ny","send":"styles_send__zrX6B"};